<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-select v-model="queryForm.semesterCode" placeholder="学年学期" style="width: 220px;" clearable>
                <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button v-if="userRole.indexOf('1')>-1" @click="showUnlockDialog" type="warning"><i class="el-icon-unlock"></i>&nbsp;解锁排课</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期编码" prop="semesterCode" align="center"></el-table-column>
            <el-table-column label="学年学期名称" prop="semesterName" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="showTimetableDialog(scope.row)">
                        <i class="el-icon-date"></i>&nbsp;课表详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 主课表信息 -->
        <el-dialog :title="timetableDialogTitle"
            :visible.sync="timetableDialogVisible"
            v-if="timetableDialogVisible"
            fullscreen :show-close="false" append-to-body>
            <experimentTimetable ref="experimentTimetable" @closeTimetableDialg="closeTimetableDialg" :curSemesterCode="curSemesterCode"></experimentTimetable>
        </el-dialog>

        <el-dialog title="解锁排课"
            :visible.sync="unlockDialogVisible"
            v-if="unlockDialogVisible"
            width="1100px" top="70px" append-to-body>
            <div style="height:650px;">
                <unlock ref="unlock"></unlock>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import unlock from 'views/timetableManage/arrange/unlock.vue';
    import experimentTimetable from 'views/timetableManage/arrange/experimentTimetable.vue';

    export default {
        components: {
            unlock,
            experimentTimetable,
        },
        data() {
            return {
                userRole: [],
                //查询列表数据
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    semesterCode: null,
                },
                //下拉框选项数据
                comboOption: {
                   semester: null,
                },
                //表数据
                tableData: [],
                total: null,
                tableLoading: true,
                mainTableHeight: 500,
                selectRowData: null,
                loadingMask: null,
                curSemesterCode: null,
                //解锁排课对话框标识
                unlockDialogVisible: false,
                //课表对话框标识
                timetableDialogVisible: false,
                timetableDialogTitle: null,
            }
        },
        mounted() {
            this.userInfo();
            this.initCombo();
            this.queryList();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            userInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;
                    if (userInfo) {
                        for (let roleCode in userInfo.roles) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole.push(roleCode);
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            initCombo() {
                this.$api.timetableManage.arrange.initCombo({}).then((res) => {
                    this.comboOption.semester = res.data.data.semesterComboData;
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queryList() {
                this.tableLoading = true;

                this.$api.timetableManage.arrange.queSemesterList({
                    data: this.queryForm,
                }).then((res) => {
                    this.total = res.data.data.total;
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handlePageChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
            },
            handleReset() {
                this.queryForm.pageNum = 1;
                this.queryForm.rowNum = 10;
                this.queryForm.semesterCode = null;
                this.queryList();
            },
            showUnlockDialog(){
                this.unlockDialogVisible = true;
                this.$nextTick().then(() => {
                    this.$refs.unlock.mainTableHeight = 550;
                });
            },
            showTimetableDialog(rowData){
                this.timetableDialogTitle = rowData.semesterName + '班级课程表信息';
                this.timetableDialogVisible = true;
                this.curSemesterCode = rowData.semesterCode;
            },
            closeTimetableDialg(){
                this.timetableDialogVisible = false;
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        }
    };
</script>
<style scoped>
    #mainTimetable .el-main {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// experimentManage.vue?a14566c2